import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingImage: ({ ctx, $t }): LandingComponentsConfig['LandingImage'] => {
			let img = null

			try {
				img = require(`@/assets/landing/calorie-deficit/calculator-${ctx.language}.webp`)
			} catch {
				img = require('@/assets/landing/calorie-deficit/calculator-en.webp')
			}

			return {
				img,
				overlayText: {
					title: $t('pages.landing.calorie_deficit_calculator_title'),
					subtitle: $t('pages.landing.calorie_deficit_calculator_subtitle'),
				},
				customStyles: {
					maxWidth: '420px',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
